import { CRUISE_DATES_FILTER } from 'components/CruiseSearchWidget/constants';
import { CalendarType } from 'components/CruiseSearchWidget/types';
import { CustomFilter } from 'components/FiltersModal/ActiveFilter/CustomFilter/CustomFilter';
import { useFiltersContext } from 'components/FiltersProvider/FiltersProvider';
import { DateRangeFilter } from 'lib/apiClient';
import { useMemo } from 'react';
import { root } from './CruiseDates.css';
import { DatesCalendar } from './DatesCalendar/DatesCalendar';
import { MonthsCalendar } from './MonthsCalendar';

interface CruiseDatesProps {
	calendarType: CalendarType;
}

const CruiseDates = ({ calendarType }: CruiseDatesProps) => {
	const { filters, enableUniqueFilters } = useFiltersContext();
	const dateFilter: DateRangeFilter = useMemo(() => filters.find((filter) => filter.key === CRUISE_DATES_FILTER.key) as DateRangeFilter, [filters]);

	return (
		<>
			{enableUniqueFilters && calendarType === CalendarType.Months && <CustomFilter />}
			<div className={root}>
				{calendarType === CalendarType.Months ? <MonthsCalendar years={dateFilter.years} /> : <DatesCalendar dateFilter={dateFilter} />}
			</div>
		</>
	);
};

export { CruiseDates };
